<template>
  <div class="new-index">
    <!-- Header 导航栏 -->
    <CommonHeader />

    <!-- Main 内容区 -->
    <main class="main-content">
      <div class="container">
        <!-- 轮播 Banner 区域 -->
        <section class="banner-section">
          <el-carousel
            ref="bannerCarousel"
            :interval="5000"
            :height="bannerHeight"
            indicator-position="none"
            arrow="never"
            @change="onBannerChange"
          >
            <el-carousel-item v-for="(banner, index) in bannerList" :key="index">
              <div class="banner-item" @click="goToVideoPlay(banner.videoId)">
                <div class="banner-bg" :style="{ backgroundImage: 'url(' + banner.image + ')' }"></div>
                <div class="banner-overlay"></div>
                <div class="banner-content">
                  <span class="banner-tag">{{ banner.tag }}</span>
                  <h2 class="banner-title">{{ banner.title }}</h2>
                  <!-- <p class="banner-desc">{{ banner.description }}</p> -->
                  <button class="banner-btn" @click.stop="goToVideoPlay(banner.videoId)">
                    <Play class="btn-icon" />
                    立即观看
                  </button>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <!-- 自定义轮播指示器 -->
          <div class="custom-indicators">
            <button
              v-for="(banner, index) in bannerList"
              :key="index"
              :class="['indicator-dot', { active: currentBannerIndex === index }]"
              @click="goToBanner(index)"
            ></button>
          </div>
        </section>

        <!-- 最新视频区域 -->
        <section class="video-section">
          <div class="section-header">
            <div class="section-title">
              <h2>最新视频</h2>
            </div>
            <a @click="viewAllLatest" class="view-all" style="cursor: pointer;">
              查看全部
              <ArrowRight class="icon-sm" />
            </a>
          </div>
          <div class="video-grid">
            <div
              v-for="(video, index) in latestVideos"
              :key="index"
              class="video-card"
              @click="goToVideoPlay(video.videoId)"
            >
              <div class="video-thumbnail">
                <div class="thumbnail-bg" :style="{ backgroundImage: 'url(' + video.thumbnail + ')' }"></div>
                <div class="video-watch-status">
                  <WatchStatusBadge :status="video.watchStatus" />
                </div>
                <div class="video-duration">{{ video.duration }}</div>
                <div class="video-overlay">
                  <PlayCircle class="play-icon" />
                </div>
              </div>
              <div class="video-info">
                <span :class="['video-category', video.categoryClass]">{{ video.category }}</span>
                <h3 class="video-title">{{ video.title }}</h3>
                <div class="video-meta">
                  <span class="video-views">
                    <Eye class="icon-sm" />
                    {{ video.views }} 次观看
                  </span>
                  <span class="video-time">{{ video.timeAgo }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- 热门推荐区域 -->
        <section class="video-section">
          <div class="section-header">
            <div class="section-title">
              <h2>热门推荐</h2>
            </div>
            <a @click="viewAllPopular" class="view-all" style="cursor: pointer;">
              查看全部
              <ArrowRight class="icon-sm" />
            </a>
          </div>
          <div class="video-grid">
            <div
              v-for="(video, index) in popularVideos"
              :key="index"
              class="video-card"
              @click="goToVideoPlay(video.videoId)"
            >
              <div class="video-thumbnail">
                <div class="thumbnail-bg" :style="{ backgroundImage: 'url(' + video.thumbnail + ')' }"></div>
                <div class="video-watch-status">
                  <WatchStatusBadge :status="video.watchStatus" />
                </div>
                <div class="video-duration">{{ video.duration }}</div>
                <div class="video-overlay">
                  <PlayCircle class="play-icon" />
                </div>
              </div>
              <div class="video-info">
                <span :class="['video-category', video.categoryClass]">{{ video.category }}</span>
                <h3 class="video-title">{{ video.title }}</h3>
                <div class="video-meta">
                  <span class="video-views">
                    <Eye class="icon-sm" />
                    {{ video.views }} 次观看
                  </span>
                  <span class="video-time">{{ video.timeAgo }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>

  </div>
</template>

<script>
import { getBannerList, getLatestVideoList, getPopularVideoList } from '../../api/api'
import CommonHeader from '../../components/header/CommonHeader.vue'
import WatchStatusBadge from '../../components/video/WatchStatusBadge.vue'
import { consumePageState, restoreWindowScroll, savePageState } from '../../utils/pageState'
import { DEFAULT_VIDEO_PLACEHOLDER } from '../../utils/placeholders'

const INDEX_PAGE_STATE_KEY = 'index-page'

export default {
  name: 'IndexNew',
  components: {
    CommonHeader,
    WatchStatusBadge
  },
  data() {
    return {
      currentBannerIndex: 0,
      bannerHeight: '480px',
      pendingScrollTop: null,
      // 轮播图数据
      bannerList: [],
      // 最新视频数据
      latestVideos: [],
      // 热门推荐数据
      popularVideos: []
    }
  },
  methods: {
    restorePageState() {
      const savedState = consumePageState(INDEX_PAGE_STATE_KEY)
      if (!savedState) {
        return
      }

      this.currentBannerIndex = savedState.currentBannerIndex || 0
      this.pendingScrollTop = Number.isFinite(savedState.scrollTop) ? savedState.scrollTop : 0
    },
    saveCurrentPageState() {
      savePageState(INDEX_PAGE_STATE_KEY, {
        currentBannerIndex: this.currentBannerIndex,
        scrollTop: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      })
    },
    restoreSavedScroll() {
      if (this.$refs.bannerCarousel && this.currentBannerIndex > 0) {
        this.$refs.bannerCarousel.setActiveItem(this.currentBannerIndex)
      }

      if (this.pendingScrollTop === null) {
        return
      }

      restoreWindowScroll(this.pendingScrollTop)
      this.pendingScrollTop = null
    },
    /**
     * 更新轮播高度
     */
    updateBannerHeight() {
      const width = window.innerWidth
      if (width <= 480) {
        this.bannerHeight = '240px'
      } else if (width <= 768) {
        this.bannerHeight = '240px'
      } else {
        this.bannerHeight = '480px'
      }
    },

    /**
     * 检查钉钉扫码登录重定向回来的 token 参数
     * 当后端重定向到首页时（http://shipin.shrysh.com/#/?token=xxx），在这里处理
     */
    checkDingTalkToken() {
      // 兼容 Hash 模式和 History 模式的参数获取
      const queryString = window.location.search || window.location.hash.split('?')[1] || ''
      const urlParams = new URLSearchParams(queryString)

      const token = urlParams.get('token')
      const error = urlParams.get('error')

      if (token) {
        this.handleDingTalkLoginSuccess(token)
      } else if (error) {
        console.error('钉钉登录失败:', error)
        this.$message.error(decodeURIComponent(error))
        // 跳转到登录页
        setTimeout(() => {
          this.$router.push('/login').catch(() => {})
        }, 2000)
      }
    },

    /**
     * 处理钉钉扫码登录成功
     */
    async handleDingTalkLoginSuccess(token) {
      try {
        // 存储 token
        this.$store.dispatch('setToken', token)

        // 获取用户信息
        await this.$store.dispatch('fetchUserInfo')

        this.$message.success('钉钉登录成功，欢迎回来！')

        // 清理 URL 中的 token 参数，保持 URL 干净
        this.$router.replace('/').catch(() => {})
      } catch (err) {
        console.error('获取用户信息失败:', err)
        this.$message.error('登录状态失效，请重新登录')

        // 跳转到登录页
        setTimeout(() => {
          this.$router.push('/login').catch(() => {})
        }, 1500)
      }
    },

    goToBanner(index) {
      this.currentBannerIndex = index
      if (this.$refs.bannerCarousel) {
        this.$refs.bannerCarousel.setActiveItem(index)
      }
    },
    onBannerChange(index) {
      this.currentBannerIndex = index
    },
    // 加载轮播视频
    async loadBannerList() {
      try {
        const res = await getBannerList()
        if (res.code === 1000 && res.data && res.data.length > 0) {
          this.bannerList = res.data
            .filter(video => video.ifCarousel === 0)
            .map(video => ({
            videoId: video.videoId,
            image: this.getImageUrl(video.videoCover),
            tag: video.categoryName ? video.categoryName.split(',')[0] : '精选活动',
            title: video.videoTitle,
            description: this.stripHtmlTags(video.videoDesc) || '精彩视频内容，立即观看'
          }))
          this.$nextTick(() => {
            this.restoreSavedScroll()
          })
        }
      } catch (error) {
        console.error('加载轮播视频失败:', error)
      }
    },
    // 加载最新视频
    async loadLatestVideos() {
      try {
        const res = await getLatestVideoList({ limit: 8 })
        if (res.code === 1000 && res.data) {
          this.latestVideos = res.data.map(video => this.formatVideoData(video))
          this.$nextTick(() => {
            this.restoreSavedScroll()
          })
        }
      } catch (error) {
        console.error('加载最新视频失败:', error)
      }
    },
    // 加载热门推荐
    async loadPopularVideos() {
      try {
        const res = await getPopularVideoList({ limit: 8 })
        if (res.code === 1000 && res.data) {
          this.popularVideos = res.data.map(video => this.formatVideoData(video))
          this.$nextTick(() => {
            this.restoreSavedScroll()
          })
        }
      } catch (error) {
        console.error('加载热门推荐失败:', error)
      }
    },
    // 格式化视频数据
    formatVideoData(video) {
      return {
        videoId: video.videoId,
        thumbnail: this.getImageUrl(video.videoCover),
        duration: this.formatDuration(video.duration),
        category: video.categoryName ? video.categoryName.split(',')[0] : '未分类',
        categoryClass: this.getCategoryClass(video.categoryName),
        title: video.videoTitle,
        views: this.formatNumber(video.viewCount || 0),
        timeAgo: this.formatTimeAgo(video.createTime),
        watchStatus: video.watchStatus || '待观看'
      }
    },
    // 获取图片URL
    getImageUrl(path) {
      if (!path) return DEFAULT_VIDEO_PLACEHOLDER
      if (path.startsWith('http')) return path
      return this.$store.state.HOST + path
    },
    // 格式化时长（秒转为 mm:ss 格式）
    formatDuration(seconds) {
      if (!seconds) return '00:00'
      const mins = Math.floor(seconds / 60)
      const secs = seconds % 60
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },
    // 格式化数字
    formatNumber(num) {
      if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'k'
      }
      return num.toString()
    },
    // 格式化时间
    formatTimeAgo(dateString) {
      if (!dateString) return '刚刚'
      const date = new Date(dateString)
      const now = new Date()
      const diff = now - date
      const seconds = Math.floor(diff / 1000)
      const minutes = Math.floor(seconds / 60)
      const hours = Math.floor(minutes / 60)
      const days = Math.floor(hours / 24)
      const months = Math.floor(days / 30)

      if (months > 0) return months + ' 个月前'
      if (days > 0) return days + ' 天前'
      if (hours > 0) return hours + ' 小时前'
      if (minutes > 0) return minutes + ' 分钟前'
      return '刚刚'
    },
    // 获取分类样式类
    getCategoryClass(categoryName) {
      const classes = ['category-blue', 'category-red', 'category-purple', 'category-green', 'category-orange', 'category-indigo']
      if (!categoryName) return classes[0]
      const hash = categoryName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
      return classes[hash % classes.length]
    },
    // 去除HTML标签，提取纯文本
    stripHtmlTags(html) {
      if (!html) return ''
      const div = document.createElement('div')
      div.innerHTML = html
      return div.textContent || div.innerText || ''
    },
    // 查看全部最新视频
    viewAllLatest() {
      this.$router.push({ path: '/videoList', query: { type: 'latest' } })
    },
    // 查看全部热门推荐
    viewAllPopular() {
      this.$router.push({ path: '/videoList', query: { type: 'popular' } })
    },
    // 跳转到视频播放页
    goToVideoPlay(videoId) {
      if (!videoId) return
      this.saveCurrentPageState()
      this.$router.push({ path: '/videoPlay', query: { id: videoId, from: 'public' } })
    }
  },
  mounted() {
    this.restorePageState()
    // 1. 检查 URL 中的 token 参数（钉钉扫码登录重定向回来的场景）
    this.checkDingTalkToken()

    // 2. 初始化轮播高度
    this.updateBannerHeight()

    // 3. 监听窗口大小变化
    window.addEventListener('resize', this.updateBannerHeight)

    // 4. 加载首页数据
    this.loadBannerList()
    this.loadLatestVideos()
    this.loadPopularVideos()
  },
  created() {
    // 优先处理 token，确保在任何 API 请求之前完成
    this.checkDingTalkToken()
  },
  beforeDestroy() {
    // 清理 resize 监听器
    window.removeEventListener('resize', this.updateBannerHeight)
  }
}
</script>

<style scoped>
/* 全局样式重置 */
* {
  box-sizing: border-box;
}

.new-index {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', 'Helvetica Neue', Arial, sans-serif;
  color: #101318;
  background-color: #f0f2f4;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /* 定义统一的侧边距 */
  --side-padding: 20px;
}

/* ==================== Main Content 样式 ==================== */
.main-content {
  flex: 1;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 var(--side-padding);
}

@media (max-width: 768px) {
  .container {
    --side-padding: 16px;
  }
}

@media (max-width: 480px) {
  .container {
    --side-padding: 12px;
  }
}

/* ==================== Banner 样式 ==================== */
.banner-section {
  position: relative;
  width: 100%;
  margin: 2rem 0 3rem;
  border-radius: 12px;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

@media (max-width: 768px) {
  .banner-section {
    margin: 1.5rem 0 2rem;
    border-radius: 8px;
  }
}

@media (max-width: 480px) {
  .banner-section {
    margin: 1rem 0 1.5rem;
    border-radius: 6px;
  }
}

.banner-item {
  position: relative;
  width: 100%;
  height: 480px;
  cursor: pointer;
}

.banner-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transition: transform 0.7s;
}

.banner-item:hover .banner-bg {
  transform: scale(1.05);
}

.banner-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.4), transparent);
}

.banner-content {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 3rem;
  width: 100%;
  max-width: 672px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.banner-tag {
  display: inline-block;
  padding: 4px 12px;
  background-color: rgba(26, 113, 255, 0.9);
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 2px;
  width: fit-content;
}

.banner-title {
  font-size: 24px;
  font-weight: 800;
  color: #ffffff;
  line-height: 1.2;
  margin: 0;
}

.banner-desc {
  color: #e5e7eb;
  font-size: 18px;
  line-height: 1.6;
  margin: 0;
}

.banner-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #1a71ff;
  color: #ffffff;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 6px rgba(26, 113, 255, 0.25);
  margin-top: 1rem;
  width: fit-content;
}

.banner-btn:hover {
  background-color: rgba(26, 113, 255, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(26, 113, 255, 0.3);
}

/* 响应式 Banner */
@media (max-width: 768px) {
  .banner-item {
    height: 240px;
  }

  .banner-title {
    font-size: 32px;
  }

  .banner-desc {
    font-size: 16px;
  }

  .banner-content {
    padding: 2rem;
  }

  .banner-btn {
    padding: 10px 16px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .banner-item {
    height: 240px;
  }

  .banner-title {
    font-size: 18px;
  }

  .banner-desc {
    font-size: 13px;
  }

  .banner-content {
    padding: 1.5rem;
    gap: 0.75rem;
  }

  .banner-tag {
    padding: 3px 8px;
    font-size: 10px;
  }

  .banner-btn {
    padding: 8px 12px;
    font-size: 12px;
    margin-top: 0.5rem;
  }

  .custom-indicators {
    bottom: 12px;
    right: 12px;
    gap: 6px;
  }

  .indicator-dot {
    width: 8px;
    height: 8px;
  }
}

.custom-indicators {
  position: absolute;
  bottom: 24px;
  right: 32px;
  display: flex;
  gap: 8px;
  z-index: 10;
}

.indicator-dot {
  width: 12px;
  height: 12px;
  border-radius: 9999px;
  background-color: rgba(255, 255, 255, 0.4);
  border: none;
  cursor: pointer;
  transition: all 0.3s;
  padding: 0;
}

.indicator-dot:hover {
  background-color: rgba(255, 255, 255, 0.7);
}

.indicator-dot.active {
  background-color: #ffffff;
}

/* ==================== Video Section 样式 ==================== */
.video-section {
  margin-bottom: 3rem;
}

@media (max-width: 768px) {
  .video-section {
    margin-bottom: 2rem;
  }
}

@media (max-width: 480px) {
  .video-section {
    margin-bottom: 1.5rem;
  }
}

.section-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .section-header {
    margin-bottom: 1.25rem;
  }
}

@media (max-width: 480px) {
  .section-header {
    margin-bottom: 1rem;
  }
}

.section-title h2 {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 4px 0;
  letter-spacing: -0.02em;
}

.section-title p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

@media (max-width: 768px) {
  .section-title h2 {
    font-size: 20px;
  }

  .section-title p {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .section-header {
    margin-bottom: 1rem;
  }

  .section-title h2 {
    font-size: 16px;
  }

  .section-title p {
    font-size: 11px;
  }
}

.section-title .highlight {
  font-weight: 600;
  color: #1a71ff;
}

.view-all {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #1a71ff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s;
}

.view-all:hover {
  color: rgba(26, 113, 255, 0.8);
}

/* 响应式：隐藏小屏幕"查看全部" */
@media (max-width: 768px) {
  .view-all {
    font-size: 12px;
  }
}

@media (max-width: 640px) {
  .view-all {
    display: none;
  }
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}

/* 响应式网格 */
@media (max-width: 1024px) {
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }
}

.video-card {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  border: 1px solid transparent;
  cursor: pointer;
}

.video-card:hover {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  transform: translateY(-4px);
}

@media (max-width: 480px) {
  .video-card {
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }

  .video-card:hover {
    transform: translateY(-2px);
  }
}

.video-thumbnail {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 宽高比 */
  overflow: hidden;
  background-color: #e5e7eb;
}

.thumbnail-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transition: transform 0.5s;
}

.video-card:hover .thumbnail-bg {
  transform: scale(1.1);
}

.video-duration {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 2px;
}

.video-watch-status {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
}

@media (max-width: 480px) {
  .video-duration {
    font-size: 10px;
    padding: 3px 6px;
    bottom: 6px;
    right: 6px;
  }
}

.video-overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s;
}

.video-card:hover .video-overlay {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.4);
}

.play-icon {
  color: #ffffff;
  width: 60px;
  height: 60px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.btn-icon {
  width: 20px;
  height: 20px;
  margin-right: 4px;
}

.icon-sm {
  width: 16px;
  height: 16px;
}

@media (max-width: 768px) {
  .play-icon {
    width: 48px;
    height: 48px;
  }
}

@media (max-width: 480px) {
  .play-icon {
    width: 36px;
    height: 36px;
  }
}

.video-info {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.video-category {
  font-size: 10px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 2px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  width: fit-content;
  margin-bottom: 8px;
}

@media (max-width: 768px) {
  .video-info {
    padding: 0.75rem;
  }

  .video-category {
    font-size: 9px;
    padding: 3px 6px;
  }
}

@media (max-width: 480px) {
  .video-info {
    padding: 0.5rem;
  }

  .video-category {
    font-size: 8px;
    padding: 2px 6px;
    margin-bottom: 6px;
  }
}

.category-blue {
  background-color: #dbeafe;
  color: #1e40af;
}

.category-red {
  background-color: #fee2e2;
  color: #b91c1c;
}

.category-purple {
  background-color: #ede9fe;
  color: #6b21a8;
}

.category-green {
  background-color: #d1fae5;
  color: #065f46;
}

.category-orange {
  background-color: #fed7aa;
  color: #c2410c;
}

.category-indigo {
  background-color: #e0e7ff;
  color: #3730a3;
}

.video-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  line-height: 1.4;
  margin: 0 0 8px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color 0.2s;
}

.video-card:hover .video-title {
  color: #1a71ff;
}

@media (max-width: 768px) {
  .video-title {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .video-title {
    font-size: 13px;
    margin-bottom: 6px;
  }
}

.video-meta {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #6b7280;
}

.video-views {
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (max-width: 768px) {
  .video-meta {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .video-meta {
    font-size: 10px;
    flex-wrap: wrap;
    gap: 4px;
  }

  .video-views {
    gap: 3px;
  }
}

</style>
